import { TooltipContext } from "./chunk-RZRE54IY.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Tooltip/Tooltip.tsx
import { useMemo } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var TOOLTIP_CLASSNAME_MAP = {
  placement: {
    top: "pd:tooltip__message--top",
    right: "pd:tooltip__message--right",
    bottom: "pd:tooltip__message--bottom",
    left: "pd:tooltip__message--left"
  }
};
var Tooltip = _a => {
  var _b = _a,
    {
      children,
      id,
      trigger,
      placement = "bottom",
      className
    } = _b,
    rest = __objRest(_b, ["children", "id", "trigger", "placement", "className"]);
  const context = useMemo(() => ({
    id
  }), [id]);
  return /* @__PURE__ */jsx(TooltipContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsxs("span", __spreadProps(__spreadValues({}, rest), {
      className: clsx("pd:tooltip", className),
      children: [trigger, /* @__PURE__ */jsx("span", {
        role: "tooltip",
        className: clsx("pd:tooltip__message", TOOLTIP_CLASSNAME_MAP.placement[placement]),
        id: "tooltip-".concat(id),
        children
      })]
    }))
  });
};
var Tooltip_default = Tooltip;
export { TOOLTIP_CLASSNAME_MAP, Tooltip_default };